<template>
  <v-footer>
    <v-spacer></v-spacer>
    <span>
      &copy; {{ new Date().getFullYear() }}
      <strong>Coasul Cooperativa Agroindustrial</strong>
    </span>
  </v-footer>
</template>

<script>
export default {};
</script>

<style>
</style>